import React from "react";
import { Flex, Text } from "@jsq/ds/core";
import { badgeContainerFilled, badgeText } from "./styles_vanilla.css";
import { ProfileStatus, ProfileStatusBadgeProps } from "./types";
import { PROFILE_STATUS_BADGE_MAP } from "./utils";

export const ProfileStatusBadge: React.FC<ProfileStatusBadgeProps> = ({
  status = ProfileStatus.UpdateRequired,
}) => {
  if (status === ProfileStatus.Completed) {
    return null;
  }

  const resolvedContainer = badgeContainerFilled[status];
  const statusText = PROFILE_STATUS_BADGE_MAP[status];
  const textVariant = status == ProfileStatus.UpdateRequired ? "regular-sm" : "regular-md";

  return (
    <Flex className={resolvedContainer} data-testid="badge-container">
      <Text variant={textVariant} className={badgeText[status]} data-testid="badge-text">
        {statusText}
      </Text>
    </Flex>
  );
};
